import { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { Caption1, makeStyles, tokens } from '@fluentui/react-components';
import { ChevronRight16Regular } from '@fluentui/react-icons';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalXS,
    flexWrap: 'wrap',
  },
  link: {
    color: tokens.colorNeutralForeground3,
    textDecorationLine: 'none',
    ':hover': {
      color: tokens.colorNeutralForeground2,
      textDecorationLine: 'underline',
    },
  },
  current: {
    color: tokens.colorNeutralForeground1,
    fontWeight: tokens.fontWeightSemibold,
  },
  divider: {
    color: tokens.colorNeutralForeground4,
  },
});

export type TBreadcrumbItem = {
  label: string;
  to?: string;
};

// Lightweight breadcrumb for the prototype (e.g. "Changes / CHG-2026-0007"). The
// last item is the current page and is not a link.
export const PageBreadcrumb = ({ items }: { items: TBreadcrumbItem[] }) => {
  const classes = useStyles();
  return (
    <nav aria-label="Breadcrumb" className={classes.root}>
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        return (
          <Fragment key={item.label}>
            {item.to && !isLast ? (
              <Link to={item.to} className={classes.link}>
                <Caption1 className={classes.link}>{item.label}</Caption1>
              </Link>
            ) : (
              <Caption1 className={isLast ? classes.current : classes.link} aria-current={isLast ? 'page' : undefined}>
                {item.label}
              </Caption1>
            )}
            {!isLast ? <ChevronRight16Regular className={classes.divider} /> : null}
          </Fragment>
        );
      })}
    </nav>
  );
};
